// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"8d8ad085","458":"cfb3aa83","487":"2c7e5651","858":"928d0c3e","917":"38fcb6c2"}[chunkId] + ".chunk.js";
};